<template>
  <div>
    <ForeignOrganization :v="v" />

    <div class="form-section-base__controls">
      <v-radio-group v-model="v.trusteeType.$model" row>
        <v-radio
          label="Представитель заявителя по доверенности в бумажном виде"
          :value="TrusteeType.TRUSTEE"
        />
        <v-radio
          label="Лицо действующее от имени юридического лица без доверенности"
          :value="TrusteeType.ASSIGNEE"
        />
      </v-radio-group>
    </div>

    <OrganizationTrustee
      v-if="v.trusteeType.$model === TrusteeType.TRUSTEE"
      :v="v.trustee"
      :label="TrusteeLabel.FOREIGN_ORGANIZATION"
    />
    <Assignee
      v-if="v.trusteeType.$model === TrusteeType.ASSIGNEE"
      :v="v.assignee"
      :label="TrusteeLabel.FOREIGN_ORGANIZATION"
    />
  </div>
</template>

<script>
import { getValidationErrorText } from '@/utils/validate';
import {
  FieldName,
  SubjectFillTypeText,
  TrusteeLabel,
  TrusteeType,
} from '@/constants';
import ForeignOrganization, {
  foreignOrganizationModel,
  foreignOrganizationValidation,
  prefillEsiaForeignOrg,
} from '@/components/services/EgrnConfirm/Applicant/components/ForeignOrganization';
import OrganizationTrustee, {
  organizationTrusteeModel,
  getOrganizationTrusteeValidation,
  prefillEsiaOrgTrustee,
} from '@/components/services/EgrnConfirm/Applicant/components/OrganizationTrustee';
import deepmerge from 'deepmerge';
import Assignee, {
  getAssigneeValidation,
  assigneeModel,
  prefillEsiaAssignee,
} from '@/components/services/EgrnConfirm/Applicant/components/Assignee';
import cloneDeep from 'clone-deep';

export const mrpaDisableForeignOrganizationModel = deepmerge(
  foreignOrganizationModel,
  {
    trusteeType: TrusteeType.TRUSTEE,
    trustee: organizationTrusteeModel,
    assignee: assigneeModel,
  }
);

export const getMrpaDisableForeignOrganizationValidation = (
  foreignOrganization
) => {
  const validation = deepmerge(foreignOrganizationValidation, {
    trusteeType: {},
  });

  if (foreignOrganization.trusteeType === TrusteeType.TRUSTEE) {
    validation.trustee = getOrganizationTrusteeValidation(
      foreignOrganization.trustee
    );

    return validation;
  }

  validation.assignee = getAssigneeValidation(foreignOrganization.assignee);

  return validation;
};

export const prefillEsiaMrpaDisableForeignOrganization = async () => {
  const esiaOrg = await prefillEsiaForeignOrg();

  return cloneDeep({
    ...mrpaDisableForeignOrganizationModel,
    ...esiaOrg,
    trustee: await prefillEsiaOrgTrustee(),
    assignee: await prefillEsiaAssignee(),
  });
};

export default {
  name: 'MrpaDisableForeignOrganization',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  components: {
    ForeignOrganization,
    OrganizationTrustee,
    Assignee,
  },
  data: () => ({
    TrusteeType,
    TrusteeLabel,
    getValidationErrorText,
    FieldName,
    SubjectFillTypeText,
  }),
};
</script>
